module.exports = __webpack_public_path__ + "img/eicon3-1.0b360e66.png";